import { H3, LI, SVG } from "../../../../AbstractElements";
import { Cart } from "../../../../utils/Constant";
import CartBox from "./CartBox";

const HeaderCart = () => {
  return (
    <LI className="cart-nav onhover-dropdown">
      <div className="cart-box">
        <SVG iconId='Buy'/>
      </div>
      <div className="cart-dropdown onhover-show-div">
        <H3 className="f-18 mb-0 dropdown-title">{Cart}</H3>
        <CartBox />
      </div>
    </LI>
  );
};

export default HeaderCart;
